/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getHotelList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_HOTELS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getHotelDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_HOTELS_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addHotel: (data) => {
    return axios.post(API_ENDPOINTS.ADD_HOTELS, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  updateHotel: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_HOTELS_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteHotel: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_HOTELS_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  createridebyhotel: (data) => {
  //  console.log('createride-->',data)
    return axios.post(API_ENDPOINTS.CREATE_NEW_RIDE_BY_HOTEL, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },  
  getupcomingtrips: () => {
    return axios.get(API_ENDPOINTS.GET_UPCOMINGTRIP_LISTS_HOTEL , {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getmytrips: () => {
  return axios.get(API_ENDPOINTS.GET_MYTRIP_LISTS_HOTEL , {
  headers: { isAuthRequired: true, "Content-Type": "application/json" },
  });
  },
  cancelridebyid: (id) => {
    return axios.post(API_ENDPOINTS.CANCEL_UPCOMINGRIDE_BY_HOTEL + "/" + id,  { reason: "user cancelled" },  {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
